import DemoSection from '../DemoSection';
import { UIAlert } from '../WebComponents';

export default function AlertDemo() {
  return (
    <DemoSection title="Alert 警告提示" description="警告提示，展现需要关注的信息">
      <DemoSection.Item title="类型">
        <div className="demo-content">
          <UIAlert variant="success" title="成功">
            操作成功完成
          </UIAlert>
          <UIAlert variant="error" title="错误">
            操作失败，请重试
          </UIAlert>
          <UIAlert variant="warning" title="警告">
            请注意相关事项
          </UIAlert>
          <UIAlert variant="info" title="信息">
            这是一条提示信息
          </UIAlert>
        </div>
        <div className="code-block">
          <code>{`<UIAlert variant="success" title="成功">
  操作成功完成
</UIAlert>
<UIAlert variant="error" title="错误">
  操作失败，请重试
</UIAlert>
<UIAlert variant="warning" title="警告">
  请注意相关事项
</UIAlert>
<UIAlert variant="info" title="信息">
  这是一条提示信息
</UIAlert>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
